import { Button } from "react-bootstrap";
import {
  RiArrowRightLine,
  RiCloseLine,
  RiFileCopyLine,
  RiFileDownloadLine,
  RiMapPin2Line,
  RiPhoneLine,
  RiRefund2Line,
  RiTimeLine,
  RiTruckLine,
  RiWhatsappLine,
} from "react-icons/ri";
import OrderItemRow from "./OrderItemRow";
import OrderFact from "./OrderFact";
import OrderStatusProgress from "./OrderStatusProgress";
import OrderStatusBadge from "./OrderStatusBadge";
import { formatExactDate, formatMoney } from "./orderWorkspaceFormatters";
import { canMutateSource, canReturnSource, getNextSourceStatus } from "./orderWorkspaceRules";
import styles from "./OrdersWorkspace.module.css";
const LABEL = { Confirmed: "Confirm source", Picked: "Pick source", Shipped: "Ship source", Delivered: "Deliver source" };
const hasNonZeroAmount = (value) =>
  value !== null && value !== "" && Number.isFinite(Number(value)) && Number(value) !== 0;

export default function OrderSourceCard({ order, source, movingItems = {}, onAdvanceSource, onCancelSource, onReturnSource, onMoveItem, onDownloadAirwayBill, onCopyTracking }) {
  const next = getNextSourceStatus(source.status);
  const mutable = canMutateSource(order, source);
  const tracked = source.status === "Shipped" && ["PostEx", "TCS"].includes(source.delivery_partner_name) && source.tracking_id;

  return <article className={styles.sourceCard}>
    <header className={styles.sourceHeader}>
      <div>
        <h3>{source.shop_name}</h3>
        <span>{source.order_items?.length || 0} listings · {formatMoney(source.amount)}</span>
        <div className={styles.sellerInfo}>
          {source.seller_contact && (
            <div className={styles.sellerContactRow}>
              <a href={`tel:${source.seller_contact}`} className={styles.sellerContact}><RiPhoneLine aria-hidden="true" />{source.seller_contact}</a>
              <a href={`https://wa.me/${source.seller_contact.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className={styles.sellerWhatsapp} aria-label="Chat on WhatsApp" title="Chat on WhatsApp"><RiWhatsappLine aria-hidden="true" /></a>
            </div>
          )}
          {source.seller_city && <span className={styles.sellerCity}><RiMapPin2Line aria-hidden="true" />{source.seller_city}</span>}
        </div>
      </div>
      <OrderStatusBadge status={source.status} />
    </header>
    <div className={styles.sourceFacts}>
      <OrderFact label="Delivery" value={hasNonZeroAmount(source.delivery_charges) ? formatMoney(source.delivery_charges) : ""} icon={RiTruckLine} />
      <OrderFact label="Discount" value={hasNonZeroAmount(source.discount_value) ? formatMoney(source.discount_value) : ""} icon={RiRefund2Line} />
      <OrderFact label="Placed" value={formatExactDate(source.created_at)} icon={RiTimeLine} />
      <OrderFact label="Updated" value={formatExactDate(source.updated_at)} icon={RiTimeLine} />
    </div>
    <OrderStatusProgress status={source.status} />
    <div className={styles.sourceActions}>
      {mutable && next && <Button className={`${styles.compactAction} ${styles.sourceAction} ${styles.advanceAction}`} size="sm" onClick={() => onAdvanceSource(order, source)}><RiArrowRightLine aria-hidden="true" />{LABEL[next]}</Button>}
      {mutable && <Button className={`${styles.compactAction} ${styles.sourceAction} ${styles.cancelAction}`} size="sm" variant="outline-danger" onClick={() => onCancelSource(source)}><RiCloseLine aria-hidden="true" />Cancel source</Button>}
      {canReturnSource(source) && <Button className={`${styles.compactAction} ${styles.sourceAction} ${styles.secondaryAction}`} size="sm" variant="outline-secondary" onClick={() => onReturnSource(source)}><RiRefund2Line aria-hidden="true" />Return source</Button>}
      {tracked && <Button className={`${styles.compactAction} ${styles.sourceAction} ${styles.secondaryAction}`} size="sm" variant="outline-secondary" onClick={() => onDownloadAirwayBill(source)}><RiFileDownloadLine aria-hidden="true" />Download Airway Bill</Button>}
      {tracked && <Button className={`${styles.compactAction} ${styles.sourceAction} ${styles.secondaryAction} ${styles.iconAction}`} size="sm" variant="outline-secondary" aria-label="Copy tracking number" title="Copy tracking number" onClick={() => onCopyTracking(source)}><RiFileCopyLine aria-hidden="true" /></Button>}
    </div>
    <div className={styles.itemsList}>
      {(source.order_items || []).map((item) => <OrderItemRow key={item.order_item_id} order={order} source={source} item={item} moving={Boolean(movingItems[item.order_item_id])} onMoveItem={onMoveItem} />)}
    </div>
  </article>;
}
